import React, { useState, useEffect } from "react";
import { Quote, ChevronLeft, ChevronRight } from "lucide-react";
import { useLang } from "../../i18n/LanguageContext";

const Testimonials = () => {
  const { t } = useLang();
  const items = t("testimonials.items");
  const [idx, setIdx] = useState(0);

  useEffect(() => {
    if (!Array.isArray(items)) return;
    const id = setInterval(() => {
      setIdx((i) => (i + 1) % items.length);
    }, 7000);
    return () => clearInterval(id);
  }, [items]);

  if (!Array.isArray(items)) return null;

  const current = items[idx];

  return (
    <section id="testimonios" data-testid="testimonials-section" className="section-pad bg-[#F0EFEA]">
      <div className="container-x">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 mb-16">
          <div className="lg:col-span-6">
            <div className="font-mono-label text-[#666] mb-6 flex items-center gap-3">
              <span className="inline-block w-8 h-px bg-[#A89F91]" />
              {t("testimonials.kicker")}
            </div>
            <h2 className="font-display text-4xl md:text-5xl lg:text-6xl text-[#111]">
              {t("testimonials.title")}
            </h2>
          </div>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 items-start">
          <div className="lg:col-span-1 hidden lg:block">
            <Quote size={64} strokeWidth={0.75} className="text-[#A89F91]" />
          </div>

          <div className="lg:col-span-8" key={idx}>
            <p
              data-testid="testimonial-quote"
              className="font-display text-2xl md:text-4xl lg:text-5xl text-[#111] leading-[1.15]"
              style={{ fontWeight: 500, letterSpacing: "-0.02em" }}
            >
              "{current.quote}"
            </p>
            <div className="mt-12 flex items-center gap-6">
              <div>
                <div className="font-display text-lg text-[#111]">{current.author}</div>
                <div className="font-mono-label text-[#666] mt-1">{current.role}</div>
              </div>
            </div>
          </div>

          <div className="lg:col-span-3 flex lg:justify-end items-end gap-3 mt-8 lg:mt-0">
            <button
              data-testid="testimonial-prev-btn"
              onClick={() => setIdx((i) => (i - 1 + items.length) % items.length)}
              className="w-12 h-12 border border-[#111] text-[#111] flex items-center justify-center hover:bg-[#111] hover:text-white transition-colors"
              aria-label="Previous"
            >
              <ChevronLeft size={18} strokeWidth={1.5} />
            </button>
            <button
              data-testid="testimonial-next-btn"
              onClick={() => setIdx((i) => (i + 1) % items.length)}
              className="w-12 h-12 border border-[#111] text-[#111] flex items-center justify-center hover:bg-[#111] hover:text-white transition-colors"
              aria-label="Next"
            >
              <ChevronRight size={18} strokeWidth={1.5} />
            </button>
          </div>
        </div>

        <div className="mt-16 flex gap-2">
          {items.map((_, i) => (
            <button
              key={i}
              data-testid={`testimonial-dot-${i}`}
              onClick={() => setIdx(i)}
              className={`h-px transition-all duration-500 ${
                i === idx ? "w-16 bg-[#111]" : "w-8 bg-[#A89F91]"
              }`}
              aria-label={`Testimonial ${i + 1}`}
            />
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
